export default __webpack_public_path__ + "static/media/playground_text.148048ef.png";